<template>
   <nav class="navbar navbar-fixed-top">
      <div class="container-fluid">
         <div class="navbar-left">
            <div class="navbar-btn">
               <!-- <a href="javascript:;"><router-link to="/paginaInicial"><img src="@/assets/images/logo-256x256.png" alt="Mooli Logo" class="img-fluid logo"></router-link></a> -->
               <button type="button" class="btn-toggle-offcanvas"><i class="fa fa-align-left"></i></button>
            </div>
            <form id="navbar-search" class="navbar-form search-form weight-600 font-16">
               <router-link to="/paginaInicial">
                  <i class="fa fa-home color-theme mr-2"></i><i class="fa fa-angle-right mr-2"></i>
               </router-link>
               <span class="color-theme">{{ $route.name != null ? $route.name.replace(/_/g, " ").replace(/-/g, "/") : '' }}</span>
            </form>
         </div>
         <div class="navbar-right">
            <div id="navbar-menu">
               <ul class="nav navbar-nav">
                  <li title="Alterar escola"><a href="javascript:void(0);" class="icon-menu d-none d-md-block" @click="alterarEscola"><i class="fas fa-school"></i></a></li>
                  <!-- <li><a href="javascript:void(0);" id="btnFullscreen" class="icon-menu d-none d-md-block"><i class="far fa-arrows-alt"></i></a></li> -->
                  <li><a href="javascript:;" class="icon-menu" @click="deslogar"><i class="far fa-sign-out"></i></a></li>
               </ul>
            </div>
         </div>
      </div>
   </nav>
</template>

<script>

import { mapState } from 'vuex'

export default {
	name: 'MenuNavBar',
   computed: {
      ... mapState({
         dadosUsuario: state => state.dadosUsuario,
         tokenSessao: state => state.tokenSessao,
         urlRest: state => state.urlRest
      })
   },
   methods: {
      imageError : function (e) {
         this.$store.dispatch('imageError', e)
      },
		deslogar : function () {
			this.$store.dispatch('deslogar')
      },
      alterarEscola : function () {
         this.$store.dispatch('alterarEscola')
      }
   }
}

</script>